import { Button, Card, Flex, Input, Space, Table } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';
const DynamicTableAnt = ({
  columns,
  data,
  loading,
  setSearchText,
  titleBtn,
  Placeholder,
  pathBtn,
  buttonModal,
  pageCount,
  totalCount,
  setPageCount,
  searchInput,
  rowSelection,
  paginationTable,
}) => {
  const { currentLang } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const handlePageChange = (pageNumber) => {
    setPageCount(pageNumber?.current);
  };
  const defaultPagination = totalCount
    ? {
        responsive: true,
        current: pageCount || 1,
        total: totalCount,
        pageSize: 10,
        showSizeChanger: false,
        hideOnSinglePage: true,
        itemRender: (current, type, originalElement) => {
          if (type === 'prev') {
            return (
              <div
                // onClick={handlePrevClick}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  order: 1,
                }}
              >
                <IoIosArrowRoundForward
                  size={16}
                  style={{
                    transform:
                      currentLang === 'en' ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
                <span>{currentLang === 'en' ? 'Previous' : 'السابق'}</span>
              </div>
            );
          }
          if (type === 'next') {
            return (
              <div
                // onClick={handleNextClick}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  order: -1,
                }}
              >
                <span> {currentLang === 'en' ? 'Next' : 'التالى'}</span>
                <IoIosArrowRoundBack
                  size={16}
                  style={{
                    transform:
                      currentLang === 'en' ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
              </div>
            );
          }
          return originalElement;
        },
      }
    : {
        responsive: true,
        pageSize: 10,
        showSizeChanger: false,
        hideOnSinglePage: true,
        itemRender: (current, type, originalElement) => {
          if (type === 'prev') {
            return (
              <div
                // onClick={handlePrevClick}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  order: 1,
                }}
              >
                <IoIosArrowRoundForward
                  size={16}
                  style={{
                    transform:
                      currentLang === 'en' ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
                <span>{currentLang === 'en' ? 'Previous' : 'السابق'}</span>
              </div>
            );
          }
          if (type === 'next') {
            return (
              <div
                // onClick={handleNextClick}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  order: -1,
                }}
              >
                <span> {currentLang === 'en' ? 'Next' : 'التالى'}</span>
                <IoIosArrowRoundBack
                  size={16}
                  style={{
                    transform:
                      currentLang === 'en' ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
              </div>
            );
          }
          return originalElement;
        },
      };
  return (
    <div className="table-responsive">
      <Card>
        <Flex
          style={{
            width: '100%',
            marginBottom: 16,
            justifyContent: searchInput ? 'flex-end' : 'space-between',
            alignItems: 'center',
          }}
          wrap
        >
          {searchInput ? null : (
            <Input.Search
              placeholder={
                Placeholder
                  ? Placeholder
                  : currentLang === 'en'
                  ? 'Search By Name'
                  : 'بحث بالاسم'
              }
              onSearch={(value) => setSearchText(value)}
              onChange={(value) => setSearchText(value.target.value)}
              style={{ width: 200 }}
              allowClear
              className="search-input-ant"
              // className="form-control"
              prefix={<SearchOutlined />}
            />
          )}
          {buttonModal
            ? buttonModal
            : titleBtn && (
                <Button
                  type="primary"
                  onClick={() => navigate(pathBtn)}
                  // className="button-add"
                >
                  <PlusOutlined size={10} /> {titleBtn}
                </Button>
              )}
        </Flex>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={data}
          rowSelection={rowSelection ? rowSelection : null}
          // pagination={true}
          scroll={{ x: 'max-content' }}
          // className="table"
          loading={loading}
          rowKey="key"
          pagination={paginationTable ? paginationTable : defaultPagination}
          onChange={totalCount ? handlePageChange : null}
        />
      </Card>
    </div>
  );
};

export default DynamicTableAnt;
